import React from 'react';
import './Services.css';
import { SERVICES } from '../data/services';
import { getServicePath } from '../utils/routes';
const { formatPaymentAmount, getServicePaymentConfig } = require('../shared/servicePayments');

/* ── ServiceCard sub-component ─────────────────────── */
const ServiceCard = ({ id, Icon, title, description, slug }) => {
  const paymentConfig = getServicePaymentConfig(id);
  const priceLabel = formatPaymentAmount(paymentConfig.amountPaise, paymentConfig.currency);

  return (
    <a className="service-card" href={getServicePath(slug)}>
      <div className="service-card__icon-wrap">
        <Icon />
      </div>
      <h3 className="service-card__title">{title}</h3>
      <p className="service-card__desc">{description}</p>
      <div className="service-card__price">
        <span className="service-card__price-label">Service Fee</span>
        <strong className="service-card__price-value">{priceLabel}</strong>
      </div>
    </a>
  );
};

/* ── Services section ──────────────────────────────── */
const Services = () => (
  <section id="services" className="section services">
    <div className="container">
      <h2 className="section-title">Our Services</h2>
      <p className="section-subtitle">
        Comprehensive business registration and compliance solutions tailored to your needs
      </p>

      <div className="services__grid">
        {SERVICES.map(({ id, Icon, title, description, slug }) => (
          <ServiceCard key={id} id={id} Icon={Icon} title={title} description={description} slug={slug} />
        ))}
      </div>
    </div>
  </section>
);

export default Services;
